/**
 * @file schemas/quotations.ts
 * @description 報價單 Zod 校驗 schema（前後端共用，M1）。
 */
import { z } from 'zod';
/**
 * 費用明細項目 schema。
 */
export const breakdownItemSchema = z.object({
    /** 費用項目名稱（如「初次稽核費」） */
    item: z.string().min(1).max(100),
    /** 金額（新台幣分） */
    amount: z.number().int().nonnegative(),
    /** 備注（可選） */
    note: z.string().max(200).optional(),
});
/**
 * 建立報價單請求 schema。
 * quotationCode 由後端自動生成。
 */
export const createQuotationSchema = z.object({
    /** 報價總金額（新台幣分） */
    amount: z.number().int().nonnegative(),
    /** 費用明細陣列（可選） */
    breakdown: z.array(breakdownItemSchema).optional(),
    /** 報價單 PDF 文件 ID（可選） */
    fileId: z.number().int().positive().optional(),
    /** 備注 */
    notes: z.string().max(2000).optional(),
    /** 繳費截止日期（序103；ISO 日期字串，可選） */
    paymentDueAt: z.string().datetime({ offset: true }).optional().nullable(),
});
/**
 * 確認報價單請求 schema（客戶同意時呼叫）。
 */
export const confirmQuotationSchema = z.object({
    /** 確認備注 */
    notes: z.string().max(500).optional(),
});
/**
 * 編輯報價單請求 schema（admin 糾錯用）。
 *
 * 全字段可選（partial），僅就地更新傳入字段；
 * 不影響案件 workflowState / confirmedAt。
 */
export const updateQuotationSchema = createQuotationSchema.partial();
